import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import * as React from "react";
import tw from "twin.macro";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ tw: twStyles, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} css={[tw``, twStyles]} {...props} />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ tw: twStyles, children, ...props }, ref) => (
  <AccordionPrimitive.Header tw="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      css={[
        tw`flex flex-1 items-center justify-between py-1 text-sm font-medium transition-all text-left [&[data-state=open]>svg]:rotate-180 pr-2`,
        twStyles,
      ]}
      {...props}
    >
      {children}
      <ChevronDown tw="h-5 w-5 shrink-0 transition-transform duration-200 opacity-80" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ tw: twStyles, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    tw="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div css={[tw`pb-4 pt-0`, twStyles]}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
